import React, { Component } from "react";
import PropTypes from "prop-types";
import style from "./History.module.scss";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Card,
  CardBody,
  Button,
  Table,
} from "reactstrap";
import { FormattedDate, FormattedTime } from "react-intl";
import { CircularProgress, OrderInlineDetail, ExecutionsTable } from "../..";
import { localDateTime } from "../../../utils/Helper";

class History extends Component {
  state = {
    histories: null,
    loading: true,
  };

  componentWillReceiveProps(nextProps, nextState) {
    const { orderId } = nextProps;

    if (orderId && !this.state.histories) {
      this.props.onHistoryRequest({ orderId }).then((response) => {
        this.setState({
          loading: false,
          histories: response.response.histories,
        });
      });
    }
  }

  toggle = () => {
    this.props.onToggle();
    this.setState({ histories: null, loading: true });
  };

  render() {
    const { order, open } = this.props;

    let executions = [];

    if (!open) {
      return null;
    }

    order.Childs &&
      order.Childs.forEach(
        (child) =>
          child.Executions &&
          child.Executions.forEach((exec) => executions.push({ ...exec, childId: child.ChildOrderId }))
      );

    return (
      <div>
        <Modal isOpen={this.props.open} toggle={this.toggle} className={style.modal}>
          <ModalHeader toggle={this.toggle}>
            Order history
            <OrderInlineDetail order={order} />
          </ModalHeader>
          <ModalBody style={{ padding: "10px 2px" }}>
            <Container>
              <ExecutionsTable onDelete={null} executions={executions} showDelete={false} />

              <h5 className={style.subtitle}>History</h5>
              {this.state.loading ? (
                <CircularProgress />
              ) : (
                <div className={style.histories}>
                  {this.state.histories
                    .filter((item) => item.HistoryType != "Debug")
                    .map((item) => (
                      <div className={style.item} key={`h-${item.HistoryId}`}>
                        <div className={style.header}>
                          <span className={style.user}>{item.HistoryUserName}</span>

                          <span color="secondary" className={style.time}>
                            <FormattedDate value={localDateTime(item.HistoryDateTime)} />{" "}
                            <FormattedTime value={localDateTime(item.HistoryDateTime)} hour12={false} />
                          </span>
                        </div>
                        <p>{item.HistoryDetails.trim()}</p>
                      </div>
                    ))}
                </div>
              )}
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={this.toggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default History;
